<template lang="pug">
.section
  .section-header
    template(v-if="!selectedOperatorID")
      h1 {{ $t("ui.daily_summary_sms") }}
    template(v-else)
      .section-header-back
        a.btn.btn-sm.btn-icon(href="javascript:void(0)" @click="redirect(mode = mode-1)")
          i.fas.fa-arrow-left
      h1 {{ getPageName(mode) }}
      .section-header-breadcrumb
        .breadcrumb-item
          a(href="javascript:void(0);" @click="redirect(0)") {{ $t("ui.daily_summary_sms") }}
        template(v-if="mode == 1")
          .breadcrumb-item.active
            span {{ getPageName(mode) }}
        template(v-else-if="mode == 2")
          .breadcrumb-item
            a(href="javascript:void(0);" @click="redirect(1)") {{ $t("ui.daily_summary_sms_operator") }}
          .breadcrumb-item.active
            span {{ getPageName(mode) }}
  .section-body
    .row
      .col-12
        template(v-if="selectedOperatorID")
          template(v-if="mode == 1")
            dailySummarySMSOperator(ref="dailySummarySMSOperator" :id="selectedOperatorID" :date="selectedDate" @clicked="pageMode")
          template(v-else-if="mode == 2")
            dailySummarySMSOperatorDetail(ref="dailySummarySMSOperatorDetail" :id="selectedOperatorID" :date="selectedDate")
        template(v-else)
          .card.mb-0
            .card-header
              .row.w-100
                .form-group.col-md-12.col-lg-6.col-xl-3.col-12.mb-1(v-if="!isOperator")
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-user
                    DebounceInput(autofocus type="text" v-model="searchID" :placeholder="$t('message.search_by_operator')" @enter="getDailySummarySMS(true)" size="sm")
                .form-group.col-md-12.col-lg-12.col-xl-5.col-12.mb-1
                  DateRangePicker(:value="dateRange" @update="getData")
                .form-group.col-12.mb-1
                  SubmitButton(
                    icon="fa fa-search"
                    :loading="loading"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getDailySummarySMS(true)"
                    variant="primary"
                    size="sm"
                  ).mr-2
            .card-body
              .row
                .col-10.mb-1
                  b-pagination.float-left(
                    size="sm"
                    hide-ellipsis
                    :total-rows="totalRow"
                    :per-page="getPageSize"
                    v-model="currentPage"
                    @input="changedPage($event)")
                .col-2.mb-1
                  b-input-group(:prepend="$t('ui.page_size')" size="sm")
                    b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
                .col-12(style="max-height: 70vh; overflow: hidden;")
                  .clusterize-scroll.table-responsive
                    table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                      thead.thead-light
                        tr
                          th.text-center(width="3%")
                            span #
                          th(width="10%" @click="sortOrder('account_id')")
                            span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                            .float-right
                              i(:class="changeSortKey('account_id')")
                          th.text-center(width="11%" @click="sortOrder('sms_count')")
                            span(:title="$t('ui.sms_count')") {{ $t('ui.sms_count') }}
                            .float-right
                              i(:class="changeSortKey('sms_count')")
                      tbody.clusterize-content
                        tr(v-if="smsList.length == 0")
                          td(colspan="3").text-center
                            span {{ $t('message.no_data_available') }}
                        tr(v-for="(item, index) in smsList")
                          td.text-center
                            span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                          td
                            b-link.font-weight-bold.text-info.text-decoration-none(href="javascript:void(0);" :title="item.account_id" @click="pageMode(item, 1)") {{ item.account_id }}
                          td.text-center
                            span(:title="item.sms_count") {{ item.sms_count }}
                        tr(v-if="showTotal")
                          td.text-right(colspan="2")
                            div.d-block {{ $t("ui.sub_total") }}
                            div {{ $t("ui.grand_total") }}
                          td.text-center
                            .font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalSMSCount)" :title="subTotalSMSCount") {{ subTotalSMSCount }}
                            .font-weight-bold(:class="$helpers.fontClassName(grandTotalSMSCount)" :title="grandTotalSMSCount") {{ grandTotalSMSCount }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import jsonToExcel from "@/library/jsonToExcelFull.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import dailySummarySMSOperator from "@/views/report/_dailySummarySMSOperator.vue";
import dailySummarySMSOperatorDetail from "@/views/report/_dailySummarySMSOperatorDetail.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel,
    dailySummarySMSOperator,
    dailySummarySMSOperatorDetail
  },
  data: () => ({
    loading: false,
    selectedOperatorID: null,
    selectedDate: {
      startDate: null,
      endDate: null
    },
    smsList: [],
    currentPage: 1,
    totalRow: 0,
    searchID: "",
    subTotalSMSCount: 0,
    grandTotalSMSCount: 0,
    showTotal: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null
    },
    sortKey: "account_id",
    sortType: "desc",
    mode: 0 // 0 = summarysms , 1 = summarysmsoperator, 2 = summarysmsoperatordetail
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  mounted: function() {
    if(this.$store.getters.sessionToken) {
      if(this.isOperator) {
        this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.searchID = this.accountID
        this.getDailySummarySMS(true);
      } else {
        if (this.$store.getters.reportStatement.operator_id != null)
          this.searchID = this.$store.getters.reportStatement.operator_id;

        if (this.$store.getters.reportStatement.start_date && this.$store.getters.reportStatement.end_date) {
          this.dateRange.startDate = this.$store.getters.reportStatement.start_date;
          this.dateRange.endDate = this.$store.getters.reportStatement.end_date;
        } else {
          this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
          this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
        }

        if (this.searchID.trim() != '')
          this.getDailySummarySMS(true);
      }
    }
  },
  methods: {
    redirect(mode) {
      this.mode = mode

      if(this.mode == 1) {
        var vm = this

        $(document).ready(function(){
          vm.$refs.dailySummarySMSOperator.getList()
        });
      } else {
        this.selectedOperatorID = null;
        this.getDailySummarySMS(true);
      }
    },
    getPageName(mode) {
      switch(mode){
        case 1:
          return this.$t('ui.daily_summary_sms_operator')
        case 2:
          return this.$t('ui.daily_summary_sms_operator_detail')
      }
    },
    pageMode(data, e) {
      this.selectedOperatorID = data.account_id
      this.selectedDate.startDate = this.dateRange.startDate
      this.selectedDate.endDate = this.dateRange.endDate
      if(data.working_date != null) {
        this.selectedDate.startDate = data.working_date
        this.selectedDate.endDate = data.working_date
      }
      this.mode = e
      var vm = this

      $(document).ready(function(){
        switch(e) {
          case 1:
            vm.$refs.dailySummarySMSOperator.getList()
            break
          case 2:
            vm.$refs.dailySummarySMSOperatorDetail.getList()
            break
        }
      });
    },
    clearDateRange() {
      this.dateRange.startDate = null;
      this.dateRange.endDate = null;
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getDailySummarySMS(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    setReportStatementParam() {
      var json = {
        operator_id: this.searchID.trim(),
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };

      this.$store.dispatch("user/setReportStatementParam", json);
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getDailySummarySMS(true);
    },
    getDailySummarySMS: function(isSearch) {
      if (this.checkDateRange()) {
        this.setReportStatementParam();
        let url = config.dailySummarySMSUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.searchID.trim(),
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotal()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;

                if (this.feedback.success == true) {
                  if(response.data.ds.smslist.length > 0) {
                    this.showTotal = true;
                    response.data.ds.smslist.forEach(value => {
                      this.subTotalSMSCount = parseFloat(this.subTotalSMSCount) + parseFloat(value["sms_count"]);
                    });


                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalSMSCount = response.data.ds.grand_total[0]["sms_count"];
                    }

                    this.smsList = response.data.ds.smslist;
                    this.totalRow = response.data.ds.smslist.length > 0 ? this.smsList[0]["totalrows"] : 0
                  } else {
                    this.clearTotal()
                  }
                } else {
                  this.clearTotal()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotal();
        this.smsList = [];
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    clearTotal() {
      this.showTotal = false
      this.smsList = []
      this.totalRow = 0
      this.subTotalSMSCount = 0
      this.grandTotalSMSCount = 0
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getDailySummarySMS(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getDailySummarySMS();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>